import { user } from "./axios";

interface PresignedUrlResponse {
  key: string;
  uploadUrl: string;
  url: string;
}

export interface UploadResult {
  key: string;
  url: string;
}

const getContentType = (file: File | Blob | string): string => {
  if (typeof file === "string") {
    return "application/json";
  }
  return file.type || "application/octet-stream";
};

export const uploadImage = async (
  key: string,
  file: File | Blob | string
): Promise<UploadResult> => {
  const contentType = getContentType(file);

  const response = await user.post<{
    data: PresignedUrlResponse;
  }>("/upload/presigned-url", { key, contentType });

  const { key: s3Key, uploadUrl, url } = response.data.data;

  const uploadResponse = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error(`Upload failed with status ${uploadResponse.status}`);
  }

  return { key: s3Key, url };
};
